import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import { TranslatePipe } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faThumbsUp, faThumbsDown, faKey } from '@fortawesome/pro-regular-svg-icons';
import { faApple, faGoogle } from '@fortawesome/free-brands-svg-icons';

@Component({
    selector: 'app-global-announcement-modal',
    imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogModule,
    MatButtonModule,
    TranslatePipe,
    FaIconComponent
],
    templateUrl: './link-account-modal.component.html',
    styleUrl: './link-account-modal.component.scss'
})
export class LinkAccountModalComponent {
  readonly dialogRef = inject(MatDialogRef<LinkAccountModalComponent>);
  readonly data = inject(MAT_DIALOG_DATA);

  protected readonly faThumbsDown = faThumbsDown;
  protected readonly faThumbsUp = faThumbsUp;
  protected readonly faKey = faKey;

  protected readonly faGoogle = faGoogle;
  protected readonly faApple = faApple;
}

